import { FormInstance } from 'antd'
import React from 'react'
import { TextAreaRef } from 'antd/es/input/TextArea'
import FormulaSource from '../FormulaSource'
import { useAuthorizedData } from '../../../../utils/Authorizable/authorize'
import { useFunctions } from '../../../../pages/settings/company/keyFigures/formulas/functions'

interface FormulaSourceFieldProps {
  form: FormInstance
  cursor: { select: (start: number, end?: number) => void; selectionStart: any; selectionEnd: any } | null
  textAreaRef: TextAreaRef | null
  setTextAreaRef: (ref: TextAreaRef | null) => void
}

const FormulaSourceField: React.FC<FormulaSourceFieldProps> = ({ form, cursor, textAreaRef, setTextAreaRef }) => {
  const functions = useAuthorizedData(useFunctions())

  return (
    <FormulaSource
      cursor={cursor}
      form={form}
      functions={functions}
      textAreaRef={textAreaRef}
      setTextAreaRef={setTextAreaRef}
    />
  )
}

export default FormulaSourceField
